// extracted by mini-css-extract-plugin
export default {"iconsWrapper":"logs-icon-wrapper_iconsWrapper__hJ+3w","icon":"logs-icon-wrapper_icon__ThfPU"};